var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-grid-global.lit.scss';
import styles from './sds-grid.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-grid-container` is a layout component that provides a flexible grid system for organizing content.
 * It allows developers to create responsive, grid-based layouts with consistent spacing and alignment.
 *
 * The component acts as a container for grid items, which can be customized using various styles
 * to create complex layouts that adapt to different screen sizes.
 *
 * This component is useful for structuring content into rows and columns, making it ideal for dashboards,
 * forms, and other interfaces requiring organized content presentation.
 *
 * @tag sds-grid-container
 */
let SdsGrid = (() => {
    var _SdsGrid_gap_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-grid-container')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _gap_decorators;
    let _gap_initializers = [];
    let _gap_extraInitializers = [];
    var SdsGrid = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsGrid_gap_accessor_storage.set(this, __runInitializers(this, _gap_initializers, ''));
            this._stylesGlobal = (__runInitializers(this, _gap_extraInitializers), stylesGlobal);
        }
        /**
         * Gap of this component.
         * @attr
         */
        get gap() { return __classPrivateFieldGet(this, _SdsGrid_gap_accessor_storage, "f"); }
        set gap(value) { __classPrivateFieldSet(this, _SdsGrid_gap_accessor_storage, value, "f"); }
        async firstUpdated() {
            await this.updateComplete;
            appendStylesToTheStyleRoot(this, 'sds-grid-container', this._stylesGlobal.cssText);
        }
        willUpdate(changedProperties) {
            if (changedProperties.has('gap') && this.gap) {
                const rowGap = this.gap.split(' ')[0];
                const colGap = this.gap.split(' ')[1];
                this.style.gap = `${rowGap}px ${colGap ? colGap + 'px' : ''}`;
            }
        }
        render() {
            return html `
            <div class="sds-grid-container">
                <slot></slot>
            </div>
        `;
        }
    };
    _SdsGrid_gap_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsGrid");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _gap_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _gap_decorators, { kind: "accessor", name: "gap", static: false, private: false, access: { has: obj => "gap" in obj, get: obj => obj.gap, set: (obj, value) => { obj.gap = value; } }, metadata: _metadata }, _gap_initializers, _gap_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsGrid = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsGrid = _classThis;
})();
export { SdsGrid };
